<template>
  <div class="row menu">
    <div class="col-12">
      <MenuTitle :img="titleImg" class="menu_title">
        {{ title }}
      </MenuTitle>
    </div>
    <div
      ref="scrollContainer"
      v-if="collections.length"
      class="col-12 menu_tags"
    >
      <div @click="scrollRight" class="tag_prev" />
      <div class="tag_group">
        <Tag
          v-for="(tag, index) in innerTags"
          :tag="tag"
          :active="tag.active"
          :key="tag.id"
          :index="index"
          @remote-check-tag="checkTag"
          @scroll-to-el="scrollToEl"
          :category="type"
        />
      </div>
      <div @click="scrollLeft" class="tag_next" />
    </div>
    <!-- Подборка -->
    <template v-if="collection">
      <div class="col-12">
        <CardGroup
          :items="collection"
          :type="type"
          class="menu_cardlist"
        />
        <!--				<CardRecomendedSlider :items="collection" :type="type" class="menu_slider"/>-->
      </div>
      <div class="col-12 menu_close-container">
        <div class="menu_close menu_close-start" />
        <div class="menu_close-text">
          конец подборки
          {{ endMenuText }}
        </div>
        <div class="menu_close menu_close-end" />
      </div>
    </template>
    <!-- Основной листинг -->
    <div class="col-12">
      <CardGroup
        :items="items"
        :collectionIds="collectionIds"
        :type="type"
        class="menu_cardlist"
      />
      <!-- <CardRecomendedSlider :items="items" :collectionIds="collectionIds" :type="type" class="menu_slider"/>-->

      <div v-if="description" class="category-text">
        <show-more-text
          :lines="3"
        >
          <PlainText v-html="description" />
        </show-more-text>
      </div>
    </div>
    <LoaderOverScreen v-if="loading" />
  </div>
</template>

<script>
import MenuTitle from '@/components/UI/MenuTitle'
import CardGroup from '@/components/page/CardGroup'
import CardRecomendedSlider from '@/components/page/CardRecomendedSlider'
import Tag from '@/components/UI/Tag'
import LoaderOverScreen from '@/components/UI/LoaderOverScreen'
import { mapGetters } from 'vuex'
import PlainText from '~/components/UI/PlainText'
import ShowMoreText from '~/components/UI/ShowMoreText'

export default {
  components: {
    ShowMoreText,
    PlainText,
    MenuTitle,
    CardGroup,
    CardRecomendedSlider,
    Tag,
    LoaderOverScreen,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    collections: {
      type: Array,
      default: () => ([]),
    },
    title: {
      type: String,
      default: '',
    },
    titleImg: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    initialCompilationState: {
      type: [Object, String],
      default () {
        return null
      },
    },
    initialCompilationTitle: {
      type: String,
      default: '',
    },
    initialDefaultCompilation: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      innerTags: [],
      loading: false,
      collectionsList: [],
      collection: null,
      wantedCollection: null,
      spaceForTag: 20,
      scrollSize: 100,
    }
  },
  computed: {
    ...mapGetters({
      pageTitle: 'seo/getPageTitle',
    }),
    collectionIds () {
      return this.collection ? this.collection.map(v => v.id) : null
    },
    collectionTitle () {
      return this.wantedCollection ? this.wantedCollection.name : ''
    },
    endMenuText () {
      return (
        this.collectionTitle.toLowerCase() ||
        this.initialCompilationTitle.toLowerCase()
      )
    },
    scrollContainer () {
      return this.$refs.scrollContainer
    },
  },
  mounted () {
    this.innerTags = [...this.collections]

    if (this.initialCompilationState) {
      this.$axios
        .get(
          this.$store.getters['api/menuSingleCollection'](
            this.initialCompilationState,
            'desktop',
          ),
        )
        .then((res) => {
          this.collection = res.data.items[0].menuItems
        })
    } else if (this.initialDefaultCompilation) {
      const collectionId = this.collections.find(
        v => v.slug === this.initialDefaultCompilation,
      )?.id
      const index = this.collections.findIndex(
        v => v.slug === this.initialDefaultCompilation,
      )
      this.checkTag({
        collectionId,
        index,
        target: `default_${this.type}`,
        type: 'desktop',
      })
    }
  },
  methods: {
    checkTag (data) {
      this.loading = true
      this.clearCollection()
      if (!this.innerTags[data.index].active) {
        this.$axios
          .get(
            this.$store.getters['api/menuSingleCollection'](
              data.target,
              data.type,
            ),
          )
          .then((res) => {
            this.collectionsList = res.data.items
            this.wantedCollection = this.collectionsList.find(
              v => v.id === data.collectionId,
            )
            this.collection = this.wantedCollection
              ? this.wantedCollection.menuItems
              : (() => {
                this.$toast.error(
                  'Ошибка экспорта подборки',
                  { duration: 3000 },
                )
                return null
              })()
            this.innerTags = this.innerTags.map((v, i) => {
              if (data.index === i) {
                v.active = true
              } else {
                v.active = false
              }

              return v
            })
          })
          .catch((err) => {
            this.$toast.error(err?.response?.data?.message, {
              duration: 3000,
            })
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.innerTags = this.innerTags.map((v, i) => {
          v.active = false
          return v
        })
        this.clearCollection()
        this.loading = false
      }
    },

    scrollToEl (posX) {
      this.scrollContainer.scrollLeft = posX - this.spaceForTag
    },

    scrollRight () {
      if (this.scrollContainer.scrollLeft - this.scrollSize < 0) {
        this.scrollContainer.scrollLeft = 0
      } else {
        this.scrollContainer.scrollLeft -= this.scrollSize
      }
    },

    scrollLeft () {
      this.scrollContainer.scrollLeft += this.scrollSize
    },

    clearCollection () {
      this.collection = null
    },

    uncheckTags () {
      this.innerTags.forEach((element) => {
        element.active = false
      })
    },
  },
}
</script>

<style lang="less">
.menu {
  position: relative;

  &_tags {
    margin-bottom: 25px;
    @media (max-width: 768px) {
      display: flex;
      width: 100%;
      overflow: scroll;
      height: 36px;
      .tag_group {
        flex-wrap: nowrap;
      }
    }
  }

  &_close {
    width: 390px;
    height: 17px;
    background-image: url('/compiation_end-new.svg');
    background-size: cover;
    background-repeat: no-repeat;
    transition: all ease 0.5s;

    &-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      margin-bottom: 23px;
      font-size: 20px;
    }

    &-start {
      margin-right: 20px;
    }

    &-end {
      margin-left: 20px;
    }

    span {
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 500;
      font-size: 20px;
      text-align: center;
    }
  }

  .tag_prev,
  .tag_next {
    height: 36px;
    width: 20px;
    background-color: #d8d8d8;
    position: absolute;
    justify-content: center;
    align-items: center;
    display: none;

    &::after,
    &::before {
      content: '';
      position: relative;
      width: 1px;
      height: 10px;
      background-color: black;
    }

    &::after {
      transform: rotate(130deg);
      top: 5px;
      left: -1px;
    }

    &::before {
      transform: rotate(45deg);
      bottom: 2px;
    }
  }

  .tag_prev {
    left: 0;
  }

  .tag_next {
    right: 0;
    transform: rotate(180deg);

    &::after {
      top: 3px;
      left: -1px;
    }

    &::before {
      bottom: 4px;
    }
  }

  .category-text {
    padding-top: 30px;
    text-align: justify;

    h2 {
      font-size: 15px;
    }

    p {
      font-size: 13px;
    }
  }

  @media (max-width: 1024px) {
    .menu_close-text {
      flex: none;
      width: 182px;
      text-align: center;
    }
  }

  @media (max-width: 768px) {
    .tag_prev,
    .tag_next {
      display: flex;
    }
  }
}
</style>
